export const defaultOption = {
    default: '0px',
    target: ['paragraph', 'heading'],
    options: [
        {
            label: '0',
            value: '0px',
        },
        {
            label: '0.5',
            value: '0.5px',
        },
        {
            label: '1',
            value: '1px',
        },
        {
            label: '1.5',
            value: '1.5px',
        },
    ],
};
//# sourceMappingURL=data.js.map